/* global wpApiSettings */

import formMessage from './form-message.js';

let $form;

function init() {

	$form = $('.form--login');

	if (!$form.length) {
		return;
	}

	$form.on('submit', (event) => {
		event.preventDefault();
		handleFormSubmit(event);
	});

}

function handleFormSubmit(event) {

	const formData = new FormData($form.get(0));

	let $formSubmit = $form.find('.form__submit');

	$formSubmit.prop('disabled', true).addClass('is--loading');

	$.ajax({
		url: $form.attr('action'),
		method: 'POST',
		processData: false,
		contentType: false,
		beforeSend: (xhr) => {
			xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
		},
		data: formData
	})
	.done((data, textStatus, jqXHR) => {

		if (jqXHR.status === 200) {
			document.location = '/hallinta/';
		} else {
			console.warn(data, textStatus);
		}

	})
	.fail((jqXHR, textStatus, errorThrown) => {
		if (jqXHR.responseJSON.code === 'invalid_username') {
			formMessage.handleEverything($form, 'Virheellinen käyttäjätunnus.', 'error');
		} else if (jqXHR.responseJSON.code === 'incorrect_password') {
			formMessage.handleEverything($form, `Antamasi salasana käyttäjätunnukselle ${$form.find('[name="user_login"]').val()} on virheellinen.`, 'error');
		} else {
			formMessage.handleEverything($form, jqXHR.responseJSON.message, 'error');
		}
		$formSubmit.prop('disabled', false).removeClass('is--loading');
	});

}

export default {
	init
};
